import PropTypes from "prop-types";
import React from "react";

/**
 * The `Default` component represents promos that are rendered if a promo
 * doesn't have a specific type.
 */
function Default({ title, body, onClick }) {
  return (
    <div role="button" tabIndex="0" onClick={onClick}>
      <header>
        <h3>{title}</h3>
      </header>
      <p>{body}</p>
    </div>
  );
}

Default.defaultProps = {
  onClick: null,
};

Default.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
};

export default Default;
